"use client";
import Image from "next/image";
import AnimationContainer from "../utils/animation-container";
import { ArrowLeft, Gamepad2, Zap, Shield, Gift, Sparkles } from "lucide-react";

const Bimageslider = () => {
    return (
        <AnimationContainer className="w-full lg:h-[400px] h-[450px] relative overflow-hidden rounded-3xl" delay={0.5}>
            <div className="absolute inset-0  bg-gradient-to-r from-[#0A0512] via-[#02020257] to-[#0A0512] z-40">
            </div>

            {/* Content */}
            <div className="absolute inset-0 z-50 w-full h-full">
                <div className="flex flex-col justify-center h-full text-white px-8 lg:px-16 lg:w-2/3 w-full">
                    {/* Logo and Title */}
                    <div className="flex items-center gap-4">
                        <div className="bg-gradient-to-br from-purple-500 to-purple-700 w-12 h-12 flex items-center justify-center rounded-2xl shadow-lg shadow-purple-500/20">
                            <Gamepad2 className="w-6 h-6" />
                        </div>
                        <h1 className="text-2xl lg:text-3xl font-extrabold bg-gradient-to-r from-purple-400 to-purple-600 bg-clip-text text-transparent">
                            دنیای گیمرها، همه‌چیز در بازی تور
                        </h1>
                    </div>

                    {/* Description */}
                    <p className="text-md lg:text-lg text-gray-300 mt-6 max-w-2xl leading-relaxed">
                        یوسی پابجی، سی‌پی کالاف، گیفت کارت، استیم والت و هزاران آیتم دیگر را با بهترین قیمت و تحویل آنی دریافت کنید. از همین حالا سطح بازی خود را ارتقا دهید!
                    </p>

                    {/* CTA Button */}
                    <div className="mt-8">
                        <button className="group relative bg-purple-500/10 backdrop-blur-sm transition-all duration-300 text-white  px-4 py-2 rounded-xl">
                            <span className="flex items-center gap-2">
                                <Zap className="w-5 h-5 group-hover:animate-pulse" />
                                خرید سریع و مطمئن
                            </span>
                        </button>
                    </div>

                    {/* Features */}
                    <div className="mt-8 flex flex-wrap gap-3">
                        <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-purple-500/10 backdrop-blur-sm border border-purple-500/20">
                            <Zap className="w-4 h-4 text-purple-400" />
                            <span className="text-sm text-gray-300">تحویل آنی</span>
                        </div>
                        <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-purple-500/10 backdrop-blur-sm border border-purple-500/20">
                            <Shield className="w-4 h-4 text-purple-400" />
                            <span className="text-sm text-gray-300">پشتیبانی ۲۴/۷</span>
                        </div>
                        <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-purple-500/10 backdrop-blur-sm border border-purple-500/20">
                            <Gift className="w-4 h-4 text-purple-400" />
                            <span className="text-sm text-gray-300">قیمت مناسب</span>
                        </div>
                        <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-purple-500/10 backdrop-blur-sm border border-purple-500/20">
                            <Sparkles className="w-4 h-4 text-purple-400" />
                            <span className="text-sm text-gray-300">تنوع گسترده</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="overflow-hidden infinite-bg absolute z-30 inset-0 rounded-3xl opacity-50 ">
            </div>
        </AnimationContainer>
    );
};

export default Bimageslider;
